import React, { useEffect, useState } from 'react';
import { Loading } from 'pages/App/components/Loading';
import { SuspenseWithPerf } from 'reactfire';
import { Grid } from 'semantic-ui-react';
import { useHistoryHook } from 'services/hooks/useHistoryHook'
import HistoryItems from '../Items'


function HistoryContentOrganisationCore({ uid, oid }: any) {

  const { collections: { historyOrg } } = useHistoryHook(oid);

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    historyOrg().then((historyItems: any) => {
      setData(historyItems)
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Grid.Row>
        {loading ?
          <Loading /> :
          <HistoryItems oid={oid} historyData={data} />
        }
      </Grid.Row>
    </>
  );
}

function HistoryContentOrganisation(props: any) {
  return (
    <SuspenseWithPerf
      fallback={<Loading />}
      traceId={`howwee-history-${props.oid || ''}-${props.uid || ''}`}
    >
      <HistoryContentOrganisationCore {...props} />
    </SuspenseWithPerf>
  )
}

export default HistoryContentOrganisation;